<template>
  <div :class="`block--${type}`">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.block--cards {
  position: relative;
  z-index: 1;
  padding-bottom: 15px;
  @media (min-width: $breakpoint-md) {
    margin-bottom: -70px;
    padding-bottom: 35px;
  }
}

.block--reverse {
  padding-top: 24px;
  padding-bottom: 24px;
  color: $--color-white;
  background-color: $--color-purple-light;
  text-align: center;

  @media (min-width: $breakpoint-sm) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  @media (min-width: $breakpoint-md) {
    padding-top: 70px;
  }
}
</style>
